type ConfettiOverlayProps = {
  badgePool?: string[];
};

export default function ConfettiOverlay({ badgePool = [] }: ConfettiOverlayProps) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 9998,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <style>{`
        @keyframes confettiFadeSlideUp {
          from { opacity: 0; transform: translateY(1.25rem) scale(0.9); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes confettiBounce {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-0.5rem) scale(1.1); }
        }
        .confetti-overlay-inner {
          animation: confettiFadeSlideUp 0.5s ease-out;
        }
        .confetti-badge {
          animation: confettiBounce 0.6s ease-in-out infinite;
        }
      `}</style>

      <div className="bg-[rgba(0,0,0,0.4)] absolute inset-0 backdrop-blur-sm" />

      <div className="confetti-overlay-inner relative text-center">
        <div className="text-4xl mb-3 flex justify-center gap-3">
          {badgePool.slice(0, 5).map((emoji) => (
            <span
              key={emoji}
              className="confetti-badge inline-block"
              style={{ animationDelay: `${badgePool.indexOf(emoji) * 0.1}s` }}
            >
              {emoji}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
